module.exports = __webpack_public_path__ + "img/f511d72.jpg";